import { render } from "./Organ.vue?vue&type=template&id=a9b8bfe8"
import script from "./Organ.vue?vue&type=script&lang=js"
export * from "./Organ.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__